import type { ProjectProfitTableDataQuery } from "@src/__generated__/urql-graphql";
import { makeObservable } from "mobx";
import { ProjectReportBaseModel } from "../../common/models";

type TProject = NonNullable<
  ProjectProfitTableDataQuery["projectRevenue"]
>["projects"][0];

export class ProjectProfitModel extends ProjectReportBaseModel {
  gross_profit_for_date_range: TProject["gross_profit_for_date_range"];
  filtered_profit_share: TProject["filtered_profit_share"];
  total_profit_share: TProject["total_profit_share"];
  our_work_revenue_for_date_range: TProject["our_work_revenue_for_date_range"];
  expenses_profit_for_date_range: TProject["expenses_profit_for_date_range"];

  constructor(src: TProject) {
    super(src);
    makeObservable(this);
    this.our_work_revenue_for_date_range = src.our_work_revenue_for_date_range;
    this.gross_profit_for_date_range = src.gross_profit_for_date_range;
    this.expenses_profit_for_date_range = src.expenses_profit_for_date_range;
    this.filtered_profit_share = src.filtered_profit_share;
    this.total_profit_share = src.total_profit_share;
  }
}
